module.exports = __webpack_public_path__ + "img/company.0ccb0dec.svg";